import {Injectable} from '@angular/core'
import {LogType, Logger} from '@services/utils/logger'

@Injectable({
  providedIn: 'root',
})
export class DecodeService {
  static decodeMessage(message: string): string {
    let decodedMessage = message
    try {
      if (message) {
        decodedMessage = decodeURIComponent(message)
      }
    } catch (e) {
      Logger.log(
        LogType.error,
        'Exception while decoding message in decode.service. Rollback to unprocessed.',
        e,
        message
      )
    }
    return decodedMessage
  }
}
